import {PickupLocationResponse} from 'api/dataTypes';
import classNames from 'classnames';
import {PickupPoint} from 'modules/Cart/components/PickupPoint/PickupPoint';
import {useCallback} from 'react';
import {FCC} from 'types/react';

import styles from './PickupPointsGroup.module.css';

type Props = {
    className?: string;
    points: PickupLocationResponse[];
    onSelect: (point: PickupLocationResponse) => void;
    selectedPoint?: PickupLocationResponse;
};
export const PickupPointsGroup: FCC<Props> = ({
    className,
    points,
    selectedPoint,
    onSelect,
}) => {
    const makeHandleSelectPoint = useCallback(
        (point: PickupLocationResponse) => () => {
            onSelect(point);
        },
        [onSelect],
    );

    return (
        <div className={classNames(styles.block, className)}>
            <div className={styles.points}>
                {points.map((point) => (
                    <PickupPoint
                        key={point.address}
                        title={point.address}
                        metroList={point.metroList}
                        mapUrl={point.mapUrl}
                        selected={selectedPoint?.id === point.id}
                        onSelect={makeHandleSelectPoint(point)}
                    />
                ))}
            </div>
        </div>
    );
};
